<template>
  <section class="register">
    <div class="box block-detail-box">
      <div class="header">
        <div class="title">Detalhe do bloqueio</div>
        <div @click="$emit('close')" class="close"><i class="fas fa-times"></i></div>
      </div>

      <div v-if="customer" class="detail-summary">
        <p class="detail-name">{{ customer.name }}</p>
        <p class="detail-line">{{ customer.email }}</p>
        <p class="detail-line">{{ customer.phone || '—' }}</p>
        <div class="blocked-tags">
          <span
            v-for="platform in blockedPlatforms"
            :key="platform"
            class="blocked-tag"
          >
            {{ platform }}
          </span>
        </div>
      </div>

      <div class="logs-section">
        <h3 class="logs-title">Histórico de bloqueio</h3>
        <i v-if="loadingLogs" class="fas fa-spinner loading"></i>
        <p v-else-if="!logs.length" class="logs-empty">Nenhum log de bloqueio encontrado.</p>
        <div v-else class="logs-list">
          <div v-for="log in logs" :key="log.id" class="log-item">
            <div class="log-date">{{ log.created }}</div>
            <div class="log-fields">
              <div class="log-field">
                <span class="log-label">Status</span>
                <span class="log-value" :class="{ 'log-nok': log.status === 'NOK' }">{{ log.status || '—' }}</span>
              </div>
              <div class="log-field">
                <span class="log-label">Versão</span>
                <span class="log-value">{{ log.version || '—' }}</span>
              </div>
              <div class="log-field log-field-full">
                <span class="log-label">Mensagem</span>
                <span class="log-value">{{ log.message || '—' }}</span>
              </div>
              <div class="log-field">
                <span class="log-label">Plataforma</span>
                <span class="log-value">{{ log.platform || platformLabel(log) }}</span>
              </div>
              <div class="log-field log-field-full">
                <span class="log-label">Path</span>
                <span class="log-value">{{ log.path || '—' }}</span>
              </div>
              <div v-if="log.indicator" class="log-field log-field-full">
                <span class="log-label">Indicador</span>
                <span class="log-value">{{ log.indicator }}</span>
              </div>
              <div v-if="log.token" class="log-field log-field-full">
                <span class="log-label">Token</span>
                <span class="log-value log-token">{{ log.token }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="actions block-detail-actions">
        <button @click="$emit('close')" class="button-previous">
          <i class="fas fa-angle-left"></i><span>Fechar</span>
        </button>
        <button
          @click="unblock"
          class="button-save"
          :disabled="unblocking"
        >
          <i class="fas" :class="unblocking ? 'fa-spinner loading' : 'fa-unlock'"></i>
          <span>Desbloquear</span>
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import logger from '../../logger'
import { getLogs, unblock as unblockApi } from '../api/blocks'

export default {
  name: 'BlockDetail',
  props: {
    customer: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      loadingLogs: true,
      logs: [],
      unblocking: false
    }
  },
  computed: {
    blockedPlatforms () {
      const platforms = []
      if (this.isBlockedToken(this.customer.token)) platforms.push('Profit')
      if (this.isBlockedToken(this.tokenNinjaValue(this.customer))) platforms.push('NinjaTrader')
      return platforms
    }
  },
  async mounted () {
    await this.loadLogs()
  },
  methods: {
    isBlockedToken (value) {
      return String(value || '').trim().toLowerCase() === 'bloqueado'
    },
    tokenNinjaValue (customer) {
      return customer.tokenNinja != null ? customer.tokenNinja : customer.token_ninja
    },
    platformLabel (log) {
      if (log.platform) return log.platform
      if (log.type === 'profit') return 'Profit'
      if (log.type === 'ninja') return 'NinjaTrader'
      return log.type || '—'
    },
    async loadLogs () {
      const userId = this.customer.userId || this.customer.user_id || this.customer.user
      if (!userId) return
      try {
        this.loadingLogs = true
        this.logs = await getLogs(userId)
      } catch (error) {
        logger.error(error, this)
      } finally {
        this.loadingLogs = false
      }
    },
    async unblock () {
      const userId = this.customer.userId || this.customer.user_id || this.customer.user
      if (!userId) return
      const platforms = this.blockedPlatforms.join(', ')
      const confirmed = window.confirm(`Desbloquear ${this.customer.name} (${platforms})?`)
      if (!confirmed) return
      try {
        this.unblocking = true
        await unblockApi(userId)
        this.$emit('unblocked')
      } catch (error) {
        logger.error(error, this)
      } finally {
        this.unblocking = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../_asset/scss/_variables";

.block-detail-box {
  max-width: 560px;
  width: 100%;

  .detail-summary,
  .logs-section {
    padding-left: 20px;
    padding-right: 20px;
  }
}

.detail-summary {
  margin-bottom: 24px;
  padding-top: 8px;
  padding-bottom: 20px;
  border-bottom: 1px solid $lp-border;
}

.detail-name {
  font-size: 1.15em;
  font-weight: 600;
  color: $lp-text;
  margin: 0 0 10px;
}

.detail-line {
  margin: 0 0 8px;
  color: $lp-text-2;
  font-size: 0.95em;
}

.blocked-tags {
  margin-top: 14px;
}

.blocked-tag {
  display: inline-block;
  margin-right: 6px;
  padding: 4px 10px;
  border-radius: 4px;
  background: rgba(192, 57, 43, 0.15);
  color: #c0392b;
  font-size: 0.85em;
  font-weight: 600;
}

.logs-section {
  margin-bottom: 8px;
  padding-bottom: 8px;
}

.logs-title {
  font-size: 1em;
  font-weight: 600;
  color: $lp-text;
  margin: 0 0 16px;
}

.logs-empty {
  color: $lp-text-2;
  margin: 0 0 8px;
  font-size: 0.95em;
}

.logs-list {
  max-height: 280px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-right: 4px;
}

.log-item {
  padding: 12px 14px;
  border-radius: $lp-radius;
  background: $lp-panel-2;
  border: 1px solid $lp-border;
  border-left: 3px solid #c0392b;
}

.log-date {
  font-weight: 600;
  font-size: 0.95em;
  margin-bottom: 8px;
}

.log-fields {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px 12px;
}

.log-field {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.log-field-full {
  grid-column: 1 / -1;
}

.log-label {
  font-size: 0.75em;
  font-weight: 600;
  text-transform: uppercase;
  color: $lp-text-3;
}

.log-value {
  font-size: 0.9em;
  color: $lp-text;
  word-break: break-word;
}

.log-nok {
  color: #c0392b;
  font-weight: 600;
}

.log-token {
  font-size: 0.8em;
  color: $lp-text-2;
  word-break: break-all;
}

.block-detail-actions {
  margin-top: 8px;
  padding-top: 20px;
  border-top: 1px solid $lp-border;
}
</style>
